import {CONFIRMATION_STATE} from "../../constants";

export const couldBeSkipped = (step) => step && !step.not_skippable && step.confirmationState !== CONFIRMATION_STATE.CONFIRMED